<template>
    <div v-if="isLoading" class="global-loading-overlay">
        <div class="spinner"></div>

    </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useLoadingStore } from '@/store/store/loadingStore';

const loadingStore = useLoadingStore();
const { isLoading } = storeToRefs(loadingStore);

</script>

<style scoped>
.global-loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 9998;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
}

.spinner {
    border: 8px solid rgba(0, 0, 0, 0.1);
    border-left-color: #000;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>